import React from "react"
import { useSearchParams, Link } from "react-router-dom"

const PaymentFailed = () => {
  const [searchParams] = useSearchParams()
  const reason = searchParams.get("reason")
  const eventId = searchParams.get("eventId")
  const orderId = searchParams.get("orderId")

  const reasonMessages = {
    missing_reference: "Payment reference is missing. Please try again.",
    transaction_not_found: "Transaction not found. Please contact support if payment was deducted.",
    event_not_found: "Event not found. Please try again.",
    transaction_mismatch: "Transaction verification failed. Please contact support.",
    invalid_payment_method: "Invalid payment method used. Only card and bank transfer are allowed.",
    payment_failed: "Payment was not successful. Please try again.",
    payment_cancelled: "Payment was cancelled. You can try again when ready.",
    server_error: "A server error occurred. Please try again later.",
    insufficient_tickets: "Not enough tickets available. Please try a smaller quantity."
  }

  const message = reasonMessages[reason] || "Payment was not completed. Please try again."

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-white via-slate-50 to-white px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-2xl font-bold text-slate-900">
            <span className="text-cyan-600">Obule</span>
          </Link>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-lg">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="mb-2 text-2xl font-bold text-slate-900">Payment Failed</h1>
            <p className="text-sm text-slate-600">
              {message}
            </p>
          </div>

          {orderId && (
            <div className="mb-6 rounded-lg border border-slate-100 bg-slate-50 p-4">
              <div className="flex justify-between text-sm">
                <span className="font-medium text-slate-600">Order ID:</span>
                <span className="text-slate-900 font-mono text-xs">{orderId}</span>
              </div>
            </div>
          )}

          <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50 p-4">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> If payment was deducted from your account, please contact support with your transaction reference.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {eventId ? (
              <Link
                to={`/events/${eventId}`}
                className="w-full rounded-lg bg-cyan-600 px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-cyan-700"
              >
                Try Payment Again
              </Link>
            ) : (
              <Link
                to="/events"
                className="w-full rounded-lg bg-cyan-600 px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-cyan-700"
              >
                Browse Events
              </Link>
            )}
            <Link
              to="/account/orders"
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-center text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50"
            >
              View My Orders
            </Link>
            <Link
              to="/account/support"
              className="text-center text-sm text-cyan-600 hover:text-cyan-700 font-medium"
            >
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentFailed

